import { Locale, formatDisplayableCurrency } from 'utils';
import { PriceProps } from './types';

export const Price = ({ value, currency, microcopy }: PriceProps) => {
  if (value === undefined) {
    return (
      <span className="text-md font-normal leading-[26px] tracking-[-0.108px]">
        {microcopy?.free}
      </span>
    );
  }

  return (
    <>
      {formatDisplayableCurrency(parseFloat(value), Locale.ENGLISH, currency)}
    </>
  );
};
